import React from 'react';
import Box from '@mui/system/Box';
import { useCommonStyles } from '../common';

interface PriceProps {
    price: number;
    discount?: number;
}

const Price = (props: PriceProps) => {
    const { price, discount = 10 } = props;
    const classes = useCommonStyles()
    const calculatePriceWithDiscount = (price: number, discount: number) => {
        return (price - (price*discount)/100).toFixed(0)
    }

    let priceString = discount ? calculatePriceWithDiscount(price, discount) : ''

    return <Box component="span" display="flex" flexDirection="row">
        {priceString && <Box component="h6" mr="8px">&#x20B9;{priceString}</Box>}
        <Box component="h6">&#x20B9;{discount > 0 ? <del>{price}</del> : price}</Box>
        {discount > 0 && <Box component="span" className={classes.ratingDiv} height="18px" ml="8px">
            {discount} % off
        </Box>}
    </Box>
}

export default Price;
